import { Component, OnInit } from '@angular/core';
import {
  Account,
  createAccountObject,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { Router } from '@angular/router';
import { getSuggestedStages } from '../api/explore';
import { SubscribeService } from '../subscribe.service';

@Component({
  selector: 'app-suggested-stages',
  templateUrl: './suggested-stages.component.html',
  styleUrls: ['./suggested-stages.component.scss'],
})
export class SuggestedStagesComponent implements OnInit {
  accounts: Account[] = [];
  isLoading: boolean = true;

  constructor(
    private router: Router,
    private subscribeService: SubscribeService
  ) {
    let subscribed = localStorage.getItem('subscribed_stages');
    if (subscribed) {
      subscribed = JSON.parse(subscribed);
    } else {
      subscribed = '';
    }
    getSuggestedStages([subscribed])
      .then((res) => {
        this.accounts = res.map(createAccountObject);
        this.isLoading = false;
      })
      .catch(console.error);
  }

  ngOnInit() {}

  goToStage = ({ handle }: Account) => this.router.navigate([handle]);

  toggleSubscribe = (account: Account) =>
    this.subscribeService.toggleSubscribe(account);
}
